module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1604.e2107615.jpg";